import React, { useState } from 'react';
import { toast } from 'sonner';
import { LogIn } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

// Super admins only: sign in as this user for up to 1 hour to diagnose issues.
export default function LoginAsUserButton({ target, variant = 'icon' }) {
  const { user, impersonation, startImpersonation } = useAuth();
  const [busy, setBusy] = useState(false);
  if (user?.role !== 'super_admin' || impersonation || !target || target.role === 'super_admin' || target.user_id === user.user_id) return null;

  const go = async () => {
    if (!window.confirm(`Log in as ${target.full_name || target.email}? You'll see the platform exactly as they do for up to 1 hour, and anything you do counts as them. They'll be told support viewed their account.`)) return;
    setBusy(true);
    try {
      await startImpersonation(target.user_id);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not log in as this user');
      setBusy(false);
    }
  };
  if (variant === 'button') {
    return (
      <button type="button" onClick={go} disabled={busy || target.is_active === false}
        className="flex items-center gap-2 px-4 py-2 rounded-full border border-amber-500/50 text-amber-300 text-sm hover:bg-amber-500/10 transition-colors disabled:opacity-50"
        data-testid="login-as-user-btn">
        <LogIn className="h-4 w-4" />{busy ? 'Signing in...' : 'Log in as user'}
      </button>
    );
  }
  return (
    <button type="button" onClick={go} disabled={busy || target.is_active === false} title="Log in as this user"
      className="p-2 rounded-lg text-zinc-400 hover:text-amber-300 hover:bg-amber-500/10 transition-colors disabled:opacity-40"
      data-testid={`login-as-${target.email}`}>
      <LogIn className="h-4 w-4" />
    </button>
  );
}
